module.exports = __webpack_public_path__ + "static/media/sprite-2x.425102e0.png";